import Agilite from 'agilite'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const getWorkspacesData = async (filter) => {
  try {
    const response = await agilite.Connectors.execute('transcribe_ai_workspaces', 'read', {
      filter: JSON.stringify(filter)
    })
    return response.data
  } catch (error) {
    console.error('Error getting workspace data:', error)
    return null
  }
}

export const getWorkspaceData = async (filter) => {
  try {
    const response = await agilite.Connectors.execute('transcribe_ai_workspaces', 'read_one', {
      filter: JSON.stringify(filter)
    })
    return response.data
  } catch (error) {
    console.error('Error getting workspace data:', error)
    return null
  }
}

export const createWorkspaceData = async (data) => {
  try {
    const response = await agilite.Connectors.execute('transcribe_ai_workspaces', 'create', {
      data: JSON.stringify(data)
    })
    return response.data
  } catch (error) {
    console.error('Error creating workspace data:', error)
    return null
  }
}

export const updateWorkspaceData = async (filter, data) => {
  try {
    const response = await agilite.Connectors.execute('transcribe_ai_workspaces', 'update', {
      filter: JSON.stringify(filter),
      data: JSON.stringify(data),
      options: JSON.stringify({
        upsert: true
      })
    })
    return response.data
  } catch (error) {
    console.error('Error updating workspace data:', error)
    return null
  }
}
